import _ from "lodash";
import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Home from "@/views/home/Homepage.vue";
import Login from "@/views/Login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/batches/:batchId",
    name: "Batch",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/batch/Page.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

const ready = new Promise(resolve => {
  store.watch(state => state.auth.initialized, resolve);
});

router.beforeEach((to, from, next) => {
  const needsAuth = _.find(to.matched, match => match.meta.requiresAuth);

  if (needsAuth) {
    ready.then(() => {
      if (!store.getters["auth/user"].uid) {
        next({
          path: "/login"
        });
      } else {
        next();
      }
    });
  } else {
    next();
  }
});

export default router;
